import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';

Modal.setAppElement('#root');

const MyModal = ({currentProject, darkMode}) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [modalIsOpen, setModalIsOpen] = useState(!localStorage.getItem('hasSeenModal'));
  const [showPopUp, setShowPopUp] = useState(false)

  useEffect (() => {
    const handleScroll = () =>{
      const scrolled = window.scrollY;
      if(scrolled > 2300) {
        setShowPopUp(true);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return() => {
      window.removeEventListener('scroll', handleScroll);
    }
  }, []);

  const closeModal = () => {
    setModalIsOpen(false);
    localStorage.setItem('hasSeenModal', true);
  };

  useEffect(() => {
    const handleBeforeUnload = () => {
      localStorage.removeItem('hasSeenModal');
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
    setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
    window.removeEventListener('resize', handleResize);
    };
}, []);

  const modalStyle = {
    overlay: {
      display: currentProject || darkMode ? 'none' : '',
      backgroundColor: 'transparent',
      position: 'absolute',
      
      ...(windowWidth <= 440 && {
        display: 'flex',
        justifyContent: 'center'
      }),
    },
    content: {
      position: 'relative',
      top: '2500px',
      left: '10px',
      right: 'auto',
      bottom: 'auto',
      width: '200px',
      height: '150px',
      border: '1px solid #ccc',
      borderRadius: '4px',
      padding: '10px 30px',
      backgroundColor: '#fff',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      ...(windowWidth <= 1024 && {
        top: '2450px',
        width: '150px',
        height: '150px',
        padding: '0 15px',
    }),
    ...(windowWidth <= 874 && {
      top: '2250px',
      width: '150px',
      height: '130px',
      padding: '0 15px',
  }),
  ...(windowWidth <= 730 && {
    top: '2890px',
    width: '150px',
    height: '130px',
    padding: '0 15px',
}),
  ...(windowWidth <= 440 && {
    top: '2995px',
    width: '250px',
    height: '170px',
    padding: '0 10px',
    left: '0',
  }),
  ...(windowWidth <= 361 && {
    top: '3005px',
    width: '200px',
    height: '135px',
    padding: '0 10px',
    left: '0',
  }),
  ...(windowWidth <= 320 && {
    top: '2980px',
    width: '200px',
    height: '135px',
    padding: '0 10px',
    left: '0',
  }),
    },
  };

  return (
    <div>
      {showPopUp ? ( 
          <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          contentLabel="Example Modal"
          style={modalStyle}
          className={'sliderAnimation'}
        >
          <h2 style={{fontSize: '17px', marginBottom: '12px', letterSpacing: '1px', fontFamily: 'Lora, serif', color: '#202020', fontWeight: '700',}}>Tip (:</h2>
          <p style={{fontSize: '12px', margin: '0', color: '#606060',}} >Click on the project illustrations to see their information in detail.</p>
          <button style={{background: '#4d4d4d', 
                    color: '#ffffff',
                    border: 'none', 
                    padding: '3px 15px',
                    marginRight: '20px',
                    borderRadius: '3px', 
                    cursor: 'pointer', 
                    textAlign: 'center',
                    fontWeight: '600',
                    marginTop: '1em',
                    fontSize: '12px',...(windowWidth <= 1024 && {
                    padding: '3px 10px',
                  }),}} 
                    onClick={closeModal}>Close</button>
          </Modal>
      ) : null}
      
    </div>
  );
};

export default MyModal;
